import React, { useState, useRef } from 'react';

import { Input, Select, formatDisplayValue } from '../TowerEditor';
import {
    UNITWEIGHT_CHECKEREDPLATE,
    UNITWEIGHT_DRIVEFLOOR,
    UNITWEIGHT_NONDRIVEFLOOR,
    UNITWEIGHT_ACCESSFLOOR,
    UNITWEIGHT_EXPANDEDMETAL,
    UNITWEIGHT_GRATING,
} from './constants';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeBody, summaryWeight } from '../../../modules/tower/towerWriteSlice';
import { getItemTotalWeight } from './weightSummary';


const FloorForm = ({ floors, size }) => {
    const dispatch = useDispatch();

    const [newFloor, setNewFloor] = useState(
        floors || {
            driveFloor: {
            },
            nonDriveFloor: {
            },
            accessFloor: {
            },
        },
    );
    // const { length, width } = size?.main;
    const length = parseFloat(size?.main?.length || '0');
    const width = parseFloat(size?.main?.width || '0');

    const handleChange = (e) => {
        const { name, value } = e.target;
        const strArray = name.split('.');
        const category = strArray[0];
        const key = strArray[1];

        setNewFloor((prev) => ({
            ...prev,
            [category]: {
                ...prev[category],
                [key]: value,
                // unitWeightStructure,
            },
        }));
    };

    const floorTypeTextMap = useRef({
        'N/A': 0,
        'CheckeredPlate-6t': UNITWEIGHT_CHECKEREDPLATE,
        'Grating-I25': UNITWEIGHT_GRATING,
        'ExpandedMetal-X25': UNITWEIGHT_EXPANDEDMETAL,

        'driveFloor': UNITWEIGHT_DRIVEFLOOR,
        'nonDriveFloor': UNITWEIGHT_NONDRIVEFLOOR,
        'accessFloor': UNITWEIGHT_ACCESSFLOOR,
    });

    /* Unit Weight 산정 */
    useEffect(() => {
        const updateUnitWeightStructure = (category) => {
            let unitWeight = 0;
            if (!newFloor[category].qty || newFloor[category].qty === '0') {
                unitWeight = 0;
            } else {
                unitWeight = floorTypeTextMap.current[category];
            }

            setNewFloor(prev => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    unitWeightStructure: unitWeight,
                }
            }));
        }
        
        ['driveFloor', 'nonDriveFloor', 'accessFloor'].forEach(category => {
            updateUnitWeightStructure(category);
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newFloor.driveFloor.qty, newFloor.nonDriveFloor.qty, newFloor.accessFloor.qty]);

    useEffect(() => {
        const updateUnitWeightFlooring = (category) => {
            const text = newFloor[category].flooringType;
            if (!text) {
                return;
            }

            setNewFloor((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    unitWeightFlooring: floorTypeTextMap.current[text],
                },
            }));
        };
        ['driveFloor', 'nonDriveFloor', 'accessFloor'].forEach((category) => {
            updateUnitWeightFlooring(category);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newFloor.driveFloor.flooringType, newFloor.nonDriveFloor.flooringType, newFloor.accessFloor.flooringType]);
    /* 의존성 배열 맞으므로 수정하지 말것. */

    /* 내부 계산. 면적 */
    useEffect(() => {
        const calculateFloorData = (floorType) => {
            const { qty, unitWeightStructure, flooringRatio, unitWeightFlooring } = newFloor[floorType];
            const totalAreaFloor = Math.ceil(qty * (length * width));
            const totalAreaFlooring = Math.ceil((qty * (length * width) * flooringRatio) / 100);
            const weightStructure = Math.ceil(totalAreaFloor * unitWeightStructure);
            const weightFlooring = Math.ceil(totalAreaFlooring * unitWeightFlooring);

            setNewFloor((prev) => ({
                ...prev,
                [floorType]: {
                    ...prev[floorType],
                    totalAreaFloor: totalAreaFloor || '',
                    totalAreaFlooring: totalAreaFlooring || '',
                    weightStructure: weightStructure || '',
                    // unitWeightFlooring: unitWeightFlooring || '',
                    weightFlooring: weightFlooring || '',
                    weight: weightStructure + weightFlooring || '',
                },
            }));
        };

        ['driveFloor', 'nonDriveFloor', 'accessFloor'].forEach((category) => {
            calculateFloorData(category);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        length,
        width,
        newFloor.driveFloor.qty,
        newFloor.driveFloor.unitWeightStructure,
        newFloor.driveFloor.flooringRatio,
        newFloor.driveFloor.unitWeightFlooring,
        newFloor.nonDriveFloor.qty,
        newFloor.nonDriveFloor.unitWeightStructure,
        newFloor.nonDriveFloor.flooringRatio,
        newFloor.nonDriveFloor.unitWeightFlooring,
        newFloor.accessFloor.qty,
        newFloor.accessFloor.unitWeightStructure,
        newFloor.accessFloor.flooringRatio,
        newFloor.accessFloor.unitWeightFlooring,
    ]);

    /* 리덕스에 weightSum 쓰기 */
    useEffect(() => {

        dispatch(
            summaryWeight({
                key: 'floors',
                value: getItemTotalWeight(newFloor),
            }),
        );
    }, [dispatch, newFloor]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'floors',
                value: newFloor,
            }),
        );
        // if (newFloor?.driveFloor?.weight || newFloor.nonDriveFloor?.weight || newFloor.accessFloor?.weight) {
        // }
        // return;
    }, [dispatch, newFloor]);

    return (
        <>
            <tr>
                <td>Floor</td>
            </tr>
            <tr>
                <td className="indentation">Drive</td>
                <td className="input-inside-td" colSpan={2}>
                    <Input name="driveFloor.qty" value={newFloor.driveFloor.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newFloor.driveFloor.totalAreaFloor}</td>
                <td>m2</td>
                <td className="right-align">{formatDisplayValue(newFloor.driveFloor.unitWeightStructure)}</td>
                <td className="right-align">{newFloor.driveFloor.weightStructure}</td>
            </tr>
            <tr>
                <td className="indentation">Non-Drive</td>
                <td className="input-inside-td" colSpan={2}>
                    <Input name="nonDriveFloor.qty" value={newFloor.nonDriveFloor.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newFloor.nonDriveFloor.totalAreaFloor}</td>
                <td>m2</td>
                <td className="right-align">{formatDisplayValue(newFloor.nonDriveFloor.unitWeightStructure)}</td>
                <td className="right-align">{newFloor.nonDriveFloor.weightStructure}</td>
            </tr>
            <tr>
                <td className="indentation">Access</td>
                <td className="input-inside-td" colSpan={2}>
                    <Input name="accessFloor.qty" value={newFloor.accessFloor.qty} onChange={handleChange} />
                </td>
                <td>ea</td>
                <td className="right-align">{newFloor.accessFloor.totalAreaFloor}</td>
                <td>m2</td>
                <td className="right-align">{formatDisplayValue(newFloor.accessFloor.unitWeightStructure)}</td>
                <td className="right-align">{newFloor.accessFloor.weightStructure}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
            {/* FLOORING */}
            <tr>
                <td>Flooring</td>
                <td colSpan={2}>Type</td>
                <td>Ratio, %</td>
            </tr>
            <tr>
                <td className="indentation">Drive</td>
                <td className="input-inside-td" colSpan={2}>
                    <Select
                        name="driveFloor.flooringType"
                        value={newFloor.driveFloor.flooringType}
                        onChange={handleChange}
                    >
                        <option value="" selected disabled hidden>Select...</option>
                        <option value="N/A">N/A</option>
                        <option value="CheckeredPlate-6t">Checkered Plate-6t</option>
                        <option value="Grating-I25">Grating-I25</option>
                        <option value="ExpandedMetal-X25">Expanded Metal-X24</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input
                        name="driveFloor.flooringRatio"
                        value={newFloor.driveFloor.flooringRatio}
                        onChange={handleChange}
                    />
                </td>
                <td className="right-align">{newFloor.driveFloor.totalAreaFlooring}</td>
                <td>m2</td>
                <td className="right-align">{formatDisplayValue(newFloor.driveFloor.unitWeightFlooring)}</td>
                <td className="right-align">{newFloor.driveFloor.weightFlooring}</td>
            </tr>
            <tr>
                <td className="indentation">Non-Drive</td>
                <td className="input-inside-td" colSpan={2}>
                    <Select
                        name="nonDriveFloor.flooringType"
                        value={newFloor.nonDriveFloor.flooringType}
                        onChange={handleChange}
                    >
                        <option value="" selected disabled hidden>Select...</option>
                        <option value="N/A">N/A</option>
                        <option value="CheckeredPlate-6t">Checkered Plate-6t</option>
                        <option value="Grating-I25">Grating-I25</option>
                        <option value="ExpandedMetal-X25">Expanded Metal-X24</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input
                        name="nonDriveFloor.flooringRatio"
                        value={newFloor.nonDriveFloor.flooringRatio}
                        onChange={handleChange}
                    />
                </td>
                <td className="right-align">{newFloor.nonDriveFloor.totalAreaFlooring}</td>
                <td>m2</td>
                <td className="right-align">{formatDisplayValue(newFloor.nonDriveFloor.unitWeightFlooring)}</td>
                <td className="right-align">{newFloor.nonDriveFloor.weightFlooring}</td>
            </tr>
            <tr>
                <td className="indentation">Access</td>
                <td className="input-inside-td" colSpan={2}>
                    <Select
                        name="accessFloor.flooringType"
                        value={newFloor.accessFloor.flooringType}
                        onChange={handleChange}
                    >
                        <option value="" selected disabled hidden>Select...</option>
                        <option value="N/A">N/A</option>
                        <option value="CheckeredPlate-6t">Checkered Plate-6t</option>
                        <option value="Grating-I25">Grating-I25</option>
                        <option value="ExpandedMetal-X25">Expanded Metal-X24</option>
                    </Select>
                </td>
                <td className="input-inside-td">
                    <Input
                        name="accessFloor.flooringRatio"
                        value={newFloor.accessFloor.flooringRatio}
                        onChange={handleChange}
                    />
                </td>
                <td className="right-align">{newFloor.accessFloor.totalAreaFlooring}</td>
                <td>m2</td>
                <td className="right-align">{formatDisplayValue(newFloor.accessFloor.unitWeightFlooring)}</td>
                <td className="right-align">{newFloor.accessFloor.weightFlooring}</td>
            </tr>
            <tr>
                <td className="spacer"></td>
            </tr>
        </>
    );
};

export default FloorForm;
